const regName = /^\.\/(.*)\.vue$/;
const compRequire = require.context('./', false, /\.vue$/);
const components = {};

compRequire.keys().map((path) => {
  const Instance = compRequire(path).default;
  const name = path.replace(regName, '$1');
  Instance.name = `Ui${name}`;
  components[`Ui${name}`] = Instance;
  return components;
});

export default components;
